<template>
  <div>
    <template v-if="!parentId">
      <q-alert color="primary" type="warning">Please save this company before creating comments.</q-alert>
    </template>
    <template v-else>
      <div>
        <q-input
          type="textarea"
          ref="input"
          :float-label="'Add ' + resource"
          v-model="newValue"
          :after="[
            {
              icon: 'add',
              content: true,
              handler: addHandler
            }
          ]"
        />
      </div>
      <br>
      <br>
      <q-list v-if="value && value.length && titleColumn">
        <div class="col-md-2 text-right">
          <q-btn icon="unfold_more" @click="expandAll" align="right" class="no-shadow"/>
          <q-btn icon="unfold_less" @click="collapseAll" align="right" class="no-shadow"/>
        </div>
        <br>
        <q-collapsible
          ref="collapsible"
          v-for="item in value"
          :key="item.id"
          :label="item | relationLabel(titleColumn) | niceDate"
          :subtitle="item | relationLabel(subtitleColumn)"
        >
          <div
            class="infoColumn"
            v-for="(column, columnIndex) in infoColumns"
            :key="columnIndex"
          >{{ item[column.field] }}</div>
        </q-collapsible>
      </q-list>
    </template>
  </div>
</template>
<script>
import DetailsTable from './DetailsTable'
// import { DateTime } from '../../utils/dateHelpers'
import { dateFormat } from '../../plugins/filters'

export default {
  name: 'AccordionField',
  components: { DetailsTable },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    column: {
      type: Object,
      required: true
    },
    _options: {
      type: Array,
      default: () => []
    },
    isFilter: Boolean,
    config: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      loaded: false,
      isLoading: false,
      newValue: '',
      newValues: {}
      // options: [],
    }
  },
  filters: {
    niceDate (val) {
      return dateFormat(val)
    }
  },
  computed: {
    resource () {
      return this.column.relation && this.column.relation !== 'self' ? this.column.relation.namespace : null
    },
    titleColumn () {
      return this.resource ? this.$store.getters[`${this.resource}/titleColumn`] : undefined
    },
    subtitleColumn () {
      return this.resource ? this.$store.getters[`${this.resource}/subtitleColumn`] : undefined
    },
    infoColumns () {
      return this.resource ? this.$store.getters[`${this.resource}/infoColumns`] : []
    },
    relationColumns () {
      return []
        .concat(this.titleColumn ? this.titleColumn : [])
        .concat(this.subtitleColumn ? this.subtitleColumn : [])
        .concat(this.infoColumns)
    },
    parentId () {
      return this.$route.params ? this.$route.params.id : false
    }
  },
  methods: {
    addHandler () {
      // const item = this.column.factory(this.newValue)
      const item = this.column.factory({ commentText: this.newValue, companyId: this.parentId })
      this.$emit('add', this.column.field, item)
      this.newValue = ''
      // // console.log(this.$refs.input)
      // // console.log('refs parent', parseInt(this.$refs.input.$parent.$attrs['parent-id']))
      this.$refs.input.blur()
    },
    collapseAll () {
      this.$refs.collapsible.map(item => item.hide())
    },
    expandAll () {
      this.$refs.collapsible.map(item => item.show())
    },
    serverData () {
      return this.$store.state[this.resource].records
    }
  }
}
</script>
